import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  joinQuizCode: {
    backgroundColor: "#6049EB",
    "& $joinQuizCodeContainer": {
      paddingTop: 24,
      paddingBottom: 24,
      overflow: "visible",
      "@media (max-width: 950px)": {
        paddingTop: 32,
        paddingBottom: 32,
        paddingLeft: 24,
        paddingRight: 24
      }
    }
  },
  joinQuizCodeContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 950px)": {
      flexDirection: "column"
    }
  },
  joinQuizCodeTitle: {
    color: "#FFF",
    fontSize: 20,
    fontWeight: 600,
    lineHeight: "1",
    "@media (max-width: 600px)": {
      fontSize: 16,
      lineHeight: "1.5",
      textAlign: "center"
    }
  },
  joinQuizCodeFormContainer: {
    marginLeft: 24,
    display: "flex",
    alignItems: "center",
    "@media (max-width: 950px)": {
      marginLeft: 0,
      marginTop: 16
    },
    "@media (max-width: 600px)": {
      flexDirection: "column"
    }
  },
  joinQuizCodeForm: {
    position: "relative"
  },
  joinQuizCodeInput: {
    fontFamily: "Montserrat, sans-serif",
    border: "1px solid rgba(255, 255, 255, 0.5)",
    borderRadius: 86,
    height: 56,
    outline: "none",
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1,
    maxWidth: 302,
    width: "100%",
    paddingTop: 16,
    paddingRight: 176,
    paddingBottom: 16,
    paddingLeft: 26,
    backgroundColor: "#6049EB",
    color: "#FFF",
    caretColor: "#FFF",
    transition: "border-color .3s, box-shadow .4s",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    margin: 0,
    "-webkit-appearance": "none",
    "-moz-appearance": "textfield",
    "&::placeholder": {
      color: "rgba(255, 255, 255, 0.5)",
      textAlign: "center"
    },
    "&:focus": {
      boxShadow: "0px 0px 0px 4px rgba(255, 255, 255, 0.25)",
      borderColor: "#7770FF"
    },
    "@media (max-width: 335px)": {
      paddingLeft: 12,
      paddingRight: "55%"
    }
  },
  joinQuizCodeInputError: {
    boxShadow: "0px 0px 0px 4px rgba(255, 116, 113, 0.25)",
    borderColor: "#EE426A",
    backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.5 12.75C20.5 17.1683 16.9183 20.75 12.5 20.75C8.08172 20.75 4.5 17.1683 4.5 12.75C4.5 8.33172 8.08172 4.75 12.5 4.75C16.9183 4.75 20.5 8.33172 20.5 12.75ZM12.5 22.75C18.0228 22.75 22.5 18.2728 22.5 12.75C22.5 7.22715 18.0228 2.75 12.5 2.75C6.97715 2.75 2.5 7.22715 2.5 12.75C2.5 18.2728 6.97715 22.75 12.5 22.75ZM12.5 15C11.8787 15 11.375 15.5037 11.375 16.125C11.375 16.7463 11.8787 17.25 12.5 17.25C13.1213 17.25 13.625 16.7463 13.625 16.125C13.625 15.5037 13.1213 15 12.5 15ZM12.5 8.25C11.8787 8.25 11.375 8.75368 11.375 9.375V12.75C11.375 13.3713 11.8787 13.875 12.5 13.875C13.1213 13.875 13.625 13.3713 13.625 12.75V9.375C13.625 8.75368 13.1213 8.25 12.5 8.25Z' fill='%23EE426A'/%3E%3C/svg%3E%0A\")",
    backgroundRepeat: "no-repeat",
    backgroundSize: 24,
    backgroundPosition: "center right 160px",
    paddingLeft: 14,
    paddingRight: 186,
    "@media (max-width: 335px)": {
      backgroundImage: "unset",
      paddingLeft: 16,
      paddingRight: "55%"
    }
  },
  joinQuizCodeButton: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    maxWidth: 152,
    width: "100%",
    borderRadius: 86,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    height: 56,
    "@media (max-width: 600px)": {
      width: "50%"
    }
  },
  joinQuizCodeValidationTooltip: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: "calc(100% + 20px)",
    backgroundColor: "#EE426A",
    borderRadius: 8,
    filter: "drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.08)) drop-shadow(0px 16px 16px rgba(0, 0, 0, 0.08))",
    maxWidth: "100%",
    width: "max-content",
    padding: 16,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "1.5",
    color: "#FFF",
    zIndex: 3,
    "&:after": {
      content: "''",
      width: 23,
      height: 11,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='23' height='11' viewBox='0 0 23 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.2649 8.35532C12.7184 9.83456 10.2816 9.83457 8.73511 8.35532L9.45698e-07 1.03375e-07L23 -1.90735e-06L14.2649 8.35532Z' fill='%23EE426A'/%3E%3C/svg%3E%0A\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
      display: "block",
      left: "50%",
      transform: "translateX(-50%)",
      bottom: -10,
      position: "absolute",
      zIndex: 1
    }
  },
  joinQuizCodeHotToPlay: {
    marginLeft: 24,
    color: "#FFF",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "1.75",
    textDecoration: "underline",
    cursor: "pointer",
    "@media (max-width: 950px)": {
      marginLeft: 16
    },
    "@media (max-width: 600px)": {
      marginLeft: 0,
      marginTop: 16,
      fontSize: 14,
      lineHeight: "1.4"
    }
  }
});
